import { useProps } from "./useProps";

// biome-ignore lint/suspicious/noExplicitAny: any type is necessary
export type RemoveFirstTwoFromTuple<T extends any[]> = T["length"] extends 1
  ? []
  : // biome-ignore lint/suspicious/noExplicitAny: any type is necessary
    ((...c: T) => void) extends (a: any, b: any, ...c: infer I) => void
    ? I
    : [];

// biome-ignore lint/suspicious/noExplicitAny: any type is necessary
export type PathMethodType = (year_starts: number, year_ends: number, ...args: any[]) => string;

export function useYearContext() {
  const { year_ends, year_starts } = useProps();

  const pathWithYearContext = <P extends PathMethodType>(path: P, ...args: RemoveFirstTwoFromTuple<Parameters<P>>) => {
    return path(year_starts, year_ends, ...args);
  };

  return { year_starts, year_ends, pathWithYearContext };
}
